import React, {useEffect, useState} from "react";
import {Button, Col, FormGroup, Label, Row, Spinner} from "reactstrap";
import Select from "react-select";
import {getSelectedObject} from "../../util/Helper";
import {NotificationManager} from "react-notifications";

const OrgQuestions = (props) => {
  const [orgQuestions, setOrgQuestions] = useState({});
  const relativesCount = [
    {
      value: "yes",
      label: "Yes",
    },
    {
      value: "no",
      label: "No",
    },
  ];
  const interviewExperience = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];

  useEffect(() => {
      console.log({...props.orgQuestions});
    setOrgQuestions({ ...props.candidate });
  }, []);

    const isFieldEnabled = (fieldName) =>
        props.orgQuestions.fields[fieldName]?.enabled;

    const theLabelName = (fieldName) => props.orgQuestions.fields[fieldName]?.label;

  const handleChange = (e) => {
    setOrgQuestions({
      ...orgQuestions,
      [e.target.name]: e.target.value,
    });
  };

  const handleValidation = () => {
      const {
          relativesCount,
          pastInterviews,
      } = orgQuestions;

      // Check if all fields are filled
      if (
          (isFieldEnabled("relativesCount") && !relativesCount) ||
          (isFieldEnabled("pastInterviews") && !pastInterviews)
      ) {
          //   NotificationManager.error("Please fill in all the required fields.");
          return false;
    }

      // All required fields are valid
    return true;
  };


    // const handleValidation = () => {
    //   const { relativesCount, pastInterviews } = orgQuestions;

    //   // Check if relativesCount and pastInterviews are filled
    //   if (!relativesCount || !pastInterviews) {
    //     return false;
    //   }

    //   // All validations passed, continue with further logic
    //   return true;
    // };

  const handleNext = () => {
    if (handleValidation()) {
      props.setCandidate({ ...props.candidate, ...orgQuestions });
        // props.setProgress(67);
        const newProgress = (props.progress || 0) + props.progressIncrement;
        props.setProgress(newProgress);
      props.setStep(5);
      let temp = { ...props.isCompleted };
      temp.orgQuestions = true;
      props.setIsCompleted(temp);
      props.switchComponent("candidateSpecific");
      props.gotoSlide(4);
    } else {
      NotificationManager.error("Please fill in all the required fields.");
    }
  };

    const handleFinal = async () => {
        if (handleValidation()) {
            let temp = {...props.isCompleted};
            temp.orgQuestions = true;
            props.setIsCompleted(temp);
            const completeData = {...props.candidate, ...orgQuestions};
            props.setCandidate(completeData);
            await props.handleSubmit(completeData);
        } else {
            NotificationManager.error("Please fill in all the required fields.");
        }
    };

  return (
    <div className="d-flex justify-content-between">
      <Col className="px-lg-2 mt-lg-2 pt-lg-2">
        <div className={"text-center "}>
          <h3 className="secondary-heading">Organization Related Questions</h3>
        </div>

          {isFieldEnabled("relativesCount") && (
              <Row className={"mt-4"}>
                  <Col md={12}>
                      <FormGroup>
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">
                                      <strong>
                                          {theLabelName("relativesCount")} :{" "}
                                          {/* Do you have any relatives who work for or have business
                        relations with our organization in any capacity?{" "} */}
                                          <span className={"active-text"}>*</span>
                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <Select
                                      className="react-select primary -border-none text-left input-grey-p-0"
                                      classNamePrefix="react-select"
                                      name="relativesCount"
                                      options={relativesCount}
                                      value={getSelectedObject(
                                          orgQuestions?.relativesCount,
                                          relativesCount
                                      )}
                                      onChange={(selectedOption) => {
                                          setOrgQuestions({
                                              ...orgQuestions,
                                              relativesCount: selectedOption?.value,
                                          });
                                      }}
                                  />
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              </Row>
          )}
          {isFieldEnabled("relativeDetails") && (
              <Row className={"mt-4"}>
                  <Col md={12}>
                      <Label className={"w-100 text-left ml-3"}>
                          <strong>
                              {theLabelName("relativeDetails")} :{" "}
                              {/* If yes, please specify the name and designation of your
                relative. */}
                          </strong>
                      </Label>
                      <textarea
                          className={"form-control input-grey"}
                          placeholder={theLabelName("relativeDetails")}
                          // placeholder={"Name and Designation of your relative"}
                          name={"relativeDetails"}
                          value={orgQuestions?.relativeDetails}
                          onChange={(e) => handleChange(e)}
                          style={{
                              borderRadius: "10px",
                          }}
                      ></textarea>
                  </Col>
              </Row>
          )}
          {isFieldEnabled("relationshipType") && (
              <Row className={"mt-4"}>
                  <Col md={12}>
                      <Label className={"w-100 text-left ml-3"}>
                          <strong>
                              {theLabelName("relationshipType")} :{" "}
                              {/* If yes, please specify your relationship with him/ her. */}
                          </strong>
                      </Label>
                      <textarea
                          className={"form-control input-grey"}
                          placeholder={theLabelName("relationshipType")}
                          name={"relationshipType"}
                          value={orgQuestions?.relationshipType}
                          onChange={(e) => handleChange(e)}
                          style={{
                              borderRadius: "10px",
                          }}
                      ></textarea>
                  </Col>
              </Row>
          )}
          {isFieldEnabled("pastInterviews") && (
              <Row className={"mt-4"}>
                  <Col md={12}>
                      <FormGroup>
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">
                                      <strong>
                                          {theLabelName("pastInterviews")} :{" "}
                                          {/* Have you ever been interviewed by our organisation before
                      ? */}
                                          <span className={"active-text"}>*</span>
                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <Select
                                      className="react-select primary -border-none text-left input-grey-p-0"
                                      classNamePrefix="react-select"
                                      name="pastInterviews"
                                      options={interviewExperience}
                                      value={getSelectedObject(
                                          orgQuestions?.pastInterviews,
                                          interviewExperience
                                      )}
                                      onChange={(selectedOption) => {
                                          setOrgQuestions({
                                              ...orgQuestions,
                                              pastInterviews: selectedOption?.value,
                                          });
                                      }}
                                  />
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              </Row>
          )}
          {isFieldEnabled("pastInterviewDetails") && (
              <Row className={"mt-4"}>
                  <Col md={12}>
                      <Label className={"w-100 text-left ml-3"}>
                          <strong>
                              {theLabelName("pastInterviewDetails")} :{" "}
                              {/* If yes, please specify the position and year. */}
                          </strong>
                      </Label>
                      <textarea
                          className={"form-control input-grey"}
                          placeholder={theLabelName("pastInterviewDetails")}
                          // placeholder={"Position and year"}
                          name={"pastInterviewDetails"}
                          value={orgQuestions?.pastInterviewDetails}
                          onChange={(e) => handleChange(e)}
                          style={{
                              borderRadius: "10px",
                          }}
                      ></textarea>
                  </Col>
              </Row>
          )}
        <Row className={"mt-4"}>
          <Col>
            <Button
              className="nextBtn startButton float-left"
              color={""}
              onClick={() => {
                  // props.switchComponent("experience");
                  props.switchBack();
                  const newProgress = Math.max(
                      (props.progress || 0) - props.progressIncrement,
                      0
                  ); // Ensure progress doesn’t go below 0
                  props.setProgress(newProgress);
                  // props.setProgress(50);
                props.setStep(3);
                props.gotoSlide(2);
              }}
            >
              <span className="text-white font-weight-normal">Back</span>
            </Button>
              {/* <Button
              className="beginBtn startButton float-right"
              color=""
              onClick={() => handleNext()}
            >
              <span className="text-white font-weight-normal">Next</span>
            </Button> */}
              <Button
                  className="beginBtn startButton float-right"
                  color=""
                  onClick={(e) => {
                      if (props?.lastComponent) {
                          handleFinal();
                      } else {
                          handleNext();
                      }
                  }}
              >
              <span className="text-white font-weight-normal">
                {props.lastComponent ? (
                    <>
                        {props.isLoading ? (
                            <Spinner color="light" size="sm"/>
                        ) : (
                            "Submit"
                        )}
                    </>
                ) : (
                    <>Next</>
                )}
              </span>
            </Button>
          </Col>
        </Row>
      </Col>
    </div>
  );
};

export default OrgQuestions;
